import {jsonMember, jsonObject} from "typedjson";

/**
 *  `DxUserRole` - Роль ползователя.
 **/
@jsonObject
export class DxUserRole {

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false})
  id: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  ident: string;

  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false})
  type: number;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  name: string;

  @jsonMember({constructor: String, emitDefaultValue: false, isRequired: false})
  description: string;


  constructor(fields?: Partial<DxUserRole>) {
    if (fields)
      Object.assign(this, fields);
  }
}
